import { html, type TemplateResult } from "lit";
// Figma 421:21 — 1021x607, the box this fills. Replaced 2026-08-17 with a new
// portrait from the client, cropped from 2000x1333 to the box's 1.682:1 (144 rows
// off, 110 from the top) so `object-fit: cover` has nothing left to crop. Kept at
// 2000x1189 — just under 2x the box, the widest the source allows — which is
// double the resolution of the photo it replaced at three quarters of its weight.
import palmerUrl from "./palmer.webp";

import "./artist.scss";

// Figma sets the bio as two paragraphs with a blank line between them — 6 + 7
// lines on desktop (421:17), 8 + 10 on mobile (428:844).
const BIO = [
  "Palmer is a 12-year-old artist, graphic design enthusiast, and blood cancer survivor " +
    "from Charlotte, North Carolina. While undergoing treatment for stage 3B Burkitt lymphoma " +
    "(BL), he discovered a deeper love for art by drawing over FaceTime with his brother.",
  "That creativity has now led to an unforgettable opportunity: designing his own race car paint scheme for Hendrick Motorsports and Valvoline. Palmer approaches life with " +
    "resilience, joy, and a belief that every challenge has purpose. His message to others " +
    "facing difficult circumstances is simple: “Stay joyful and be strong.”",
];

export interface ArtistProps {
  /** Overrides the bundled photo of Palmer. Figma 421:24. */
  readonly photo: string;
}

/**
 * "Meet the artist". Figma desktop: heading 421:33, photo 421:21 (1021x607) left,
 * subhead 421:18 + hand-drawn underline 421:19 + bio 421:17 right.
 * Mobile 428:836 / 428:823 / 428:828 / 428:844, stacked.
 */
export function renderArtist({ photo }: ArtistProps): TemplateResult {
  return html`
    <section class="valvoline-artist">
      <div class="valvoline-artist__inner">
        <h2 class="valvoline-artist__heading">Meet the artist</h2>

        <div class="valvoline-artist__grid">
          <div class="valvoline-artist__media">
            <!-- The alt describes the photo that is actually here, not the one
                 the FPO stood in for: a portrait of Palmer on his own, not
                 drawing and not on the Hendrick Motorsports campus. -->
            <img
              class="valvoline-artist__photo"
              src=${photo || palmerUrl}
              alt="Palmer Goforth smiling at the camera, seated at a kitchen counter with his hands clasped"
            />
          </div>

          <div class="valvoline-artist__copy">
            <h3 class="valvoline-artist__subhead">
              Meet Palmer Goforth and
              <span class="valvoline-artist__mark">take a look</span>
              at his car design
            </h3>
            ${BIO.map((paragraph) => html`<p class="valvoline-artist__bio">${paragraph}</p>`)}
          </div>
        </div>
      </div>
    </section>
  `;
}
